import { Image } from '@tracklib/kit'

// Hooks
import { useTheme } from 'modules/profile/hooks'

// Utils
import { CDN_ROOT } from '@constants'

import styles from './separator.css'

type SeparatorProps = {
  value: {
    image: number
    image_dark_mode?: number
    margin_bottom_override?: number
  }
}

const Separator = ({ value: { image, image_dark_mode, margin_bottom_override } }: SeparatorProps): JSX.Element => {
  const theme = useTheme()
  const bg = Image.getSrc(theme === 'dark' && image_dark_mode ? image_dark_mode : image, 1600, 0, 'png', false, CDN_ROOT)
  return (
    <div
      className={styles.bg}
      style={{
        backgroundImage: `url("${bg}")`,
        marginBottom: margin_bottom_override,
      }}
    />
  )
}

export default Separator
